import { isImpersonating } from '../Services/impersonationSession';
import { withMoodleIdentityCheck } from './moodleSingleLogout';

export const OPEN_COURSE_LINK_LABEL = 'Open course link';
export const OPEN_COURSE_LINK_NOTE =
  'Opens the course link only. It does not sign Moodle or Keycloak in as the learner.';

export function courseLaunchUrl(url) {
  if (!url || isImpersonating()) return url;
  return withMoodleIdentityCheck(url);
}

export function courseLaunchLabel(idleLabel, inProgress = false) {
  if (isImpersonating()) return OPEN_COURSE_LINK_LABEL;
  if (inProgress) return 'Continue learning';
  return idleLabel;
}

export function courseCardLaunchLabel(item, idleLabel) {
  const inProgress = parseFloat(item?.value) > 0;
  if (item?.isLab || !isImpersonating()) {
    return inProgress ? 'Continue learning' : idleLabel;
  }
  return OPEN_COURSE_LINK_LABEL;
}

export function coursesByUserParams(username) {
  const name = String(username || '').trim();
  if (!name) return null;
  return { username: name };
}

export function stripKeycloakCourseToken(value) {
  if (Array.isArray(value)) return value.map(stripKeycloakCourseToken);
  if (!value || typeof value !== 'object') return value;
  const next = {};
  Object.keys(value).forEach((key) => {
    if (key === 'token') return;
    next[key] = stripKeycloakCourseToken(value[key]);
  });
  return next;
}
